import {FUINavigationBranch} from "../../navigation-branches/navigation-branch/navigation-branch.model";
import {FUIIcon} from "../../../icons/icon/icon.model";

export class FUINavigationTree {
    public title: string;
    public branches?: FUINavigationBranch[];
    public icon: FUIIcon;

    constructor(object?: any) {
        this.branches = object && object.branches && object.branches.map(branch => new FUINavigationBranch(branch)) || [];
        this.icon = object && new FUIIcon(object.icon) || new FUIIcon();
        this.title = object && object.title || "";
    }
}
